exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".p404 .wrapper-main .container h3{font-size:20px;font-weight:600;color:#545454;margin-top:32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/home/404/404.scss
// module id = 580
// module chunks = 0